import { Component, OnInit, OnDestroy } from '@angular/core'
import { AuthService } from 'src/app/services/auth.service'
import { UnespCoreAuthService } from '../../services/unesp-core-auth/unesp-core-auth.service'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'unicamp-core-load',
  templateUrl: './unicamp-core-load.component.html',
  styleUrls: ['./unicamp-core-load.component.css'],
})
export class UnicampCoreLoadComponent implements OnInit, OnDestroy {
  private readonly inativeTimeMs = environment.inativeTimeInSeconds * 1000
  private hiddenAt?: number

  constructor(
    private authService: AuthService,
    private unespCoreAuthService: UnespCoreAuthService
  ) {}

  ngOnInit() {
    document.addEventListener('visibilitychange', this.onVisibilityChange)
  }

  ngOnDestroy() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
  }

  private onVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      // Tab voltou — verifica se ficou em background por mais de 30 min
      if (this.hiddenAt && (Date.now() - this.hiddenAt) >= this.inativeTimeMs) {
        this.unespCoreAuthService.logout('Sessão expirada por inatividade', true, 0)
        return
      }

      // Tab voltou dentro do prazo — registra atividade e recalcula refresh
      this.authService.registerActivity()
      if (this.authService.isLoggedIn) {
        const expiresIn = this.authService.getExpirationToken
        if (expiresIn <= this.authService['expirationRefreshTokenIntervalInSeconds']) {
          this.authService.refreshNow()
        } else {
          this.authService.startRefreshTokenTimeout(expiresIn)
        }
      }
    } else if (document.visibilityState === 'hidden') {
      this.hiddenAt = Date.now()
    }
  }
}
